/**
 * accessibility helper library
 * @author Tobias Schubert (ts@taikonauten.com)
 */

const className = 'nko';

class Accessibility {

  constructor() {

    // to test whether we have singleton or not
    this.time = new Date();

    this.lastClick = null;
    this.lastKey = null;
    this.isClick = false;
    this.isKeyup = false;
    this.tab = false;
    this.shiftTab = false;

    this.elCurrentFocuses = [];

    this.init();
  }

  init() {

    document.addEventListener('keyup', this.onKeyupListener.bind(this), false);
    document.addEventListener('click', this.onMouseListener.bind(this), false);
    document.addEventListener('mousedown', this.onMouseListener.bind(this), false);
    document.addEventListener('mouseup', this.onMouseListener.bind(this), false);
    document.addEventListener('keydown', this.onKeyDownListener.bind(this), false);
    document.addEventListener('focusout', this.onFocusOutListener.bind(this), true);
    document.addEventListener('focusin', this.onFocusInListener.bind(this), true);
    window.addEventListener('blur', this.onWindowBlur.bind(this));
  }

  onWindowBlur() {

    this.isKeyup = false;
    this.isClick = false;
    this.ignoreClickEvent = false;

    this.remove();
  }

  remove(e) {

    if (!this.elCurrentFocuses.length) {

      return;
    }

    if (e && this.elCurrentFocuses[this.elCurrentFocuses.length - 1] === e.target) {

      return;
    }

    for (let i = 0; i < this.elCurrentFocuses.length; i++) {
      if (
        this.elCurrentFocuses[i] &&
        this.elCurrentFocuses[i].classList &&
        this.elCurrentFocuses[i].classList.remove
      ) {
        this.elCurrentFocuses[i].classList.remove(className);
      }
    }

    this.elCurrentFocuses = [];
  }

  add(e) {

    if (this.isClick) {

      return;
    }

    if (!e.target) {

      return;
    }

    const index = this.elCurrentFocuses.push(e.target) - 1;
    this.elCurrentFocuses[index].classList.add(className);
  }

  onMouseListener(e) {

    if (this.ignoreClickEvent) {

      this.ignoreClickEvent = false;
      return;
    }

    this.lastClick = new Date();
    this.isKeyup = false;
    this.isClick = true;

    window.setTimeout(this.remove.bind(this, e), 0);
  }

  onKeyDownListener(e) {

    this.lastKey = new Date();
    this.isKeyup = true;
    this.isClick = false;

    if (e.which === 32 || e.which === 37 || e.which === 39 || e.which === 13) {

      this.ignoreClickEvent = true;
      return;
    }

    if (e.shiftKey && e.which === 9) {

      this.tab = false;
      this.shiftTab = true;
      return;
    }

    if (e.which === 9) {

      this.tab = true;
      this.shiftTab = false;
    }
  }

  onKeyupListener() {

    this.isKeyup = true;
    this.isClick = false;
  }

  onFocusInListener(e) {

    this.remove(e);

    if (!e || !e.target || !e.target.closest) {

      return;
    }

    window.setTimeout(this.add.bind(this, e), 0);
  }

  onFocusOutListener(e) {

    window.setTimeout(() => {

      for (let i = 0; i < this.elCurrentFocuses.length - 1; i++) {

        this.elCurrentFocuses[i].classList.remove(className);
      }

    }, 10);
  }
}

export default new Accessibility();
